<template>
    <div>这是管理页面</div>
</template>

<script>
    export default {
        name: "login"
    }
</script>

<style scoped>

</style>